import { createStyles } from "antd-style";

const useStyles = createStyles(({ css }: any) => ({
  root: css``,
}));

export const useMessageBoundaryStyles = () => {
  const styles = useStyles();

  return styles;
};
